// Vuex Departments module mutations types
export const FILL_LIST = 'FILL_LIST';
export const TOGGLE_AGENT_IN_DEPARTMENT = 'TOGGLE_AGENT_IN_DEPARTMENT';
